export default "__VITE_ASSET__CxeN2T93__"